import { render, staticRenderFns } from "./AddPallet.vue?vue&type=template&id=546350e7&"
import script from "./AddPallet.vue?vue&type=script&lang=js&"
export * from "./AddPallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports